import api from '@/services/api.js';
import qs from 'qs';

export default {
    async getOne(identifier){
        const query = qs.stringify({ _where: { 'identifier': identifier } });
        return (await api.get(`/settings?${query}`)).data[0]; 
    }
}